import { render } from "./AnamnesisWrapper.vue?vue&type=template&id=69025550&scoped=true"
import script from "./AnamnesisWrapper.vue?vue&type=script&lang=js"
export * from "./AnamnesisWrapper.vue?vue&type=script&lang=js"

import "./AnamnesisWrapper.vue?vue&type=style&index=0&id=69025550&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69025550"]])

export default __exports__